import { msg } from '@lingui/core/macro';
import { AlertTriangle, Bug, Info, Star, User, Wrench } from 'lucide-react';
import type { MessageDescriptor } from 'shared/i18n';

export * from './notification-type-labels';

/** Опции фильтров списка уведомлений; подпись переводится при показе. Форма создания держит свои (`notification-form.tsx`). */
export const typeOptions: { value: string; label: MessageDescriptor }[] = [
  { value: 'all', label: msg`Все типы` },
  { value: 'update', label: msg`Обновление` },
  { value: 'bugfix', label: msg`Исправления ошибок` },
  { value: 'maintenance', label: msg`Тех. работы` },
  { value: 'info', label: msg`Инфо` },
  { value: 'upcoming', label: msg`Будущие обновления` },
  { value: 'known_issue', label: msg`Известная проблема` },
  { value: 'user_event', label: msg`Личные события` },
];

export const sortOptions: { value: 'desc' | 'asc'; label: MessageDescriptor }[] = [
  { value: 'desc', label: msg`Новые` },
  { value: 'asc', label: msg`Старые` },
];

export const typeIconMap = {
  update: Star,
  bugfix: Bug,
  maintenance: Wrench,
  info: Info,
  upcoming: Info,
  known_issue: AlertTriangle,
  user_event: User,
};
